import {
    BOARD_ARROW_DIRECTIONS,
    type BoardKeyboardDirection,
} from "./boardDropTargets";
import { BOARD_CARD_GAP, estimateCardHeight } from "./boardWindowing";

export type BoardNavigationKey =
    | BoardKeyboardDirection
    | "home"
    | "end"
    | "pageUp"
    | "pageDown";

export const BOARD_NAVIGATION_KEYS: Partial<
    Record<string, BoardNavigationKey>
> = {
    ...BOARD_ARROW_DIRECTIONS,
    Home: "home",
    End: "end",
    PageUp: "pageUp",
    PageDown: "pageDown",
};

/** Cards a page key jumps: about a scroller's height of them. */
export const getCardsPerPage = (scrollerHeight: number) =>
    Math.max(
        1,
        Math.floor(scrollerHeight / (estimateCardHeight() + BOARD_CARD_GAP)),
    );
